if (!customElements.get('product-modal')) {
  customElements.define(
    'product-modal',
    class ProductModal extends ModalDialog {
      constructor() {
        super();
      }

      hide() {
        super.hide();
      }

      show(opener) {
        super.show(opener);
        this.showActiveMedia();
      }

      // ---- helpers ---------------------------------------------------------

      /** Apply fit-to-screen sizing to an <img> node */
      applyFitToImage(img) {
        if (!img) return;
        const apply = () => {
          img.style.width = 'auto';
          img.style.height = 'auto';
          img.style.maxWidth = '100%';
          img.style.maxHeight = '90vh';
          img.style.objectFit = 'contain';
          img.style.transform = 'none';
        };
        if (img.complete) apply();
        else img.addEventListener('load', apply, { once: true });
      }

      /** Re-apply fit after template/deferred swaps in a new <img> */
      reapplyFitAfterTemplate(activeMedia) {
        // Next frame usually catches the injected <img>; MutationObserver would also work.
        requestAnimationFrame(() => {
          const freshImg = activeMedia.querySelector('img');
          this.applyFitToImage(freshImg);
        });
      }

      /** Center the active media within the modal document container */
      centerActiveMedia(activeMedia) {
        const container = this.querySelector('[role="document"]');
        if (!container || !activeMedia) return;

        // Use offset metrics; width/left on elements can be undefined.
        const left =
          activeMedia.offsetLeft - (container.clientWidth - activeMedia.offsetWidth) / 2;

        container.scrollLeft = Math.max(0, left);
      }

      // ---- main ------------------------------------------------------------

      showActiveMedia() {
        // Deactivate all other media
        this.querySelectorAll(
          `[data-media-id]:not([data-media-id="${this.openedBy.getAttribute('data-media-id')}"])`
        ).forEach((element) => {
          element.classList.remove('active');
        });

        // Activate the media that matches the opener
        const activeMedia = this.querySelector(
          `[data-media-id="${this.openedBy.getAttribute('data-media-id')}"]`
        ) || this.querySelector('[data-media-id]');

        if (!activeMedia) return;

        const activeMediaTemplate = activeMedia.querySelector('template');
        const activeMediaContent = activeMediaTemplate ? activeMediaTemplate.content : null;

        activeMedia.classList.add('active');

        // Fit existing image immediately
        const img = activeMedia.querySelector('img');
        this.applyFitToImage(img);

        // If the media uses <template> or deferred content, re-apply fit after it swaps in
        if (activeMediaTemplate && !img) {
          this.reapplyFitAfterTemplate(activeMedia);
        }

        // Ensure active media is in view first (vertical scroll if needed)
        activeMedia.scrollIntoView({ block: 'nearest', inline: 'nearest' });

        // Horizontal centering inside the modal content container
        this.centerActiveMedia(activeMedia);

        // Load deferred YouTube/Vimeo when present
        if (
          activeMedia.nodeName === 'DEFERRED-MEDIA' &&
          activeMediaContent &&
          activeMediaContent.querySelector('.js-youtube')
        ) {
          activeMedia.loadContent();
          // Re-apply fit after the iframe/image swaps in, just in case
          this.reapplyFitAfterTemplate(activeMedia);
        }
      }
    }
  );
}
